export class DOMHelper {
    static querySelector(
        selector: string,
        element?: Element | HTMLElement | HTMLInputElement | HTMLFormElement
    ): Element | HTMLElement | HTMLInputElement | HTMLFormElement | null {
        const sourceElement = element || document;
        return sourceElement.querySelector(selector);
    }

    static querySelectorAsArray(
        selector: string,
        element?: Element
    ): Array<Element> {
        const sourceElement = element || document;
        if (sourceElement) {
            return Array.from(sourceElement.querySelectorAll(selector));
        }

        return [];
    }

    static forEachQuerySelector(
        selector: string,
        handler: (element: Element) => void,
        element?: Element
    ) {
        const elementArray = DOMHelper.querySelectorAsArray(selector, element);
        if (elementArray) {
            elementArray.forEach(handler);
        }
    }

    static mapQuerySelector(
        selector: string,
        handler: (element: Element) => any,
        element?: Element
    ) {
        const elementArray = DOMHelper.querySelectorAsArray(selector, element);
        if (elementArray) {
            return elementArray.map(handler);
        }
        return null;
    }

    static getElementById(
        selector: string
    ): Element | HTMLElement | HTMLInputElement | HTMLFormElement | null {
        return document.getElementById(selector);
    }

    static elementIsVisible(element: Element) {
        return window.getComputedStyle(element).visibility !== "hidden";
    }
}